import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil } from 'lodash';
import { Link, Settings, UrlBuilder } from '../core';
import { UserStorage } from '../user';
import { SampleTrackingOptionResolver } from './sample-tracking/sample-tracking-option.resolver';

@Component({
    selector: 'header',
    template: require('./header.component.html'),
    styles: [require('./header.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {

    public userName: Observable<string>;
    public emulatedUserFullName: Observable<string>;
    public isSampleTrackingEnabled$: Observable<boolean>;
    public isSiteShippingEnabled$: Observable<boolean>;
    public ereqLink: Link;

    constructor(userStorage: UserStorage, settings: Settings, private sampleTrackingOption: SampleTrackingOptionResolver,
                private urlBuilder: UrlBuilder) {
        const currentUser = userStorage.currentUser;

        this.userName = currentUser.pipe(map(user => user.metadata.originalUserFullName));

        if (!isNil(settings.emulatedUserId)) {
            this.emulatedUserFullName = currentUser.pipe(map(user => user.metadata.fullName));
        }

        this.isSampleTrackingEnabled$ = this.sampleTrackingOption.doesPermissionExists(currentUser);

        this.isSiteShippingEnabled$ = currentUser.pipe(map(user => user.isInvestigator));

        this.ereqLink = settings.linksDictionary['erequisition'];
    }

    public navigate() {
        this.sampleTrackingOption.navigate();
    }

    public openSiteShipping() {
        this.urlBuilder.esa().sampleManagement().registeredSamples().navigate();
    }

    public openEreq() {
        const url = this.ereqLink.url;
        window.open(url, '_blank');
    }
}